<template>
    <div>
        <div
            class="back"
            v-if="selected_level != null || selected_category != null">
            <b-button
                class="btn-back"
                variant="primary"
                @click="back()"
                >{{ $t('quest.back') }}</b-button
            >
        </div>

        <div class="row">
            <div
                class="col-lg-4 col-md-4 margin-bottom"
                v-for="level in levels"
                v-if="selected_level == null">
                <b-card
                    class="quest-choose-mission-card quest-missions-level-card"
                    header-tag="header"
                    header-class="quest-choose-mission-card-header quest-missions-level-card-header"
                    body-class="quest-choose-mission-card-content">
                    <template v-slot:header>
                        <h4 class="title">{{ level.name }}</h4>
                        <b-button
                            class="btn-access"
                            variant="primary"
                            @click="level.score <= totalscore && selectLevel(level.id)">
                            <i
                                class="fa fa-fw"
                                :class="level.score <= totalscore ? 'fa-unlock-alt color-green' : 'fa-lock color-red'"
                                aria-hidden="true"></i>
                        </b-button>
                    </template>
                    <b-card-text
                        v-if="level.score > 0"
                        text-tag="div">
                        <i18n
                            path="quest.access_from_x_points"
                            tag="div">
                            <template v-slot:x>
                                <strong>{{ level.score }}</strong>
                            </template>
                        </i18n>
                    </b-card-text>
                    <b-card-text
                        v-else
                        text-tag="div">
                        {{ $t('quest.free_access') }}
                    </b-card-text>

                    <div class="open">
                        <b-button
                            href="#"
                            variant="primary"
                            :disabled="level.score > totalscore"
                            @click="selectLevel(level.id)"
                            >{{ $t('common.open') }}</b-button
                        >
                    </div>
                </b-card>
            </div>

            <div
                class="col-lg-4 col-md-4 margin-bottom"
                v-for="category in categories"
                v-if="selected_level == category.level_id && selected_category == null">
                <b-card
                    class="quest-choose-mission-card quest-missions-category-card"
                    header-tag="header"
                    header-class="quest-choose-mission-card-header quest-missions-category-card-header"
                    body-class="quest-choose-mission-card-content">
                    <template v-slot:header>
                        <h4 class="title">{{ category.name }}</h4>
                        <b-button
                            class="btn-access"
                            variant="primary"
                            @click="category.score <= totalscore && selectCategory(category.id)">
                            <i
                                class="fa fa-fw"
                                :class="
                                    category.score <= totalscore ? 'fa-unlock-alt color-green' : 'fa-lock color-red'
                                "
                                aria-hidden="true"></i>
                        </b-button>
                    </template>
                    <b-card-text
                        v-if="category.score > 0"
                        text-tag="div">
                        <i18n
                            path="quest.access_from_x_points"
                            tag="div">
                            <template v-slot:x>
                                <strong>{{ category.score }}</strong>
                            </template>
                        </i18n>
                    </b-card-text>
                    <b-card-text
                        v-else
                        text-tag="div">
                        {{ $t('quest.free_access') }}
                    </b-card-text>

                    <div class="open">
                        <b-button
                            href="#"
                            variant="primary"
                            :disabled="category.score > totalscore"
                            @click="selectCategory(category.id)"
                            >{{ $t('common.open') }}</b-button
                        >
                    </div>
                </b-card>
            </div>

            <div
                class="col-lg-4 col-md-4 margin-bottom"
                v-for="mission in missions"
                v-if="mission.level_id == selected_level && mission.category_id === selected_category">
                <b-card
                    class="quest-choose-mission-card quest-mission-card"
                    header-tag="header"
                    header-class="quest-choose-mission-card-header quest-mission-card-header"
                    body-class="quest-choose-mission-card-content">
                    <template v-slot:header>
                        <h4 class="title">{{ mission.name }}</h4>
                        <div
                            class="done btn btn-access btn-primary"
                            v-if="checkMissionStatus(mission.id)">
                            <i
                                class="fa fa-fw"
                                :class="checkMissionStatus(mission.id)"
                                aria-hidden="true"></i>
                        </div>
                    </template>
                    <b-card-text text-tag="div">
                        <div class="difficulty">
                            {{ $t('quest.difficulty') }}<span class="difficulty-value">{{ mission.difficulty }}</span>
                        </div>

                        <div
                            class="skills"
                            v-if="mission.skills">
                            <h5>{{ $t('quest.skills') }}</h5>
                            <div
                                class="skill"
                                v-for="skill in mission.skills">
                                <span class="skill-name">
                                    {{ skill.skill.name }}
                                </span>

                                <span class="skill-value">
                                    {{ skill.value }}
                                </span>
                            </div>
                        </div>
                    </b-card-text>

                    <div class="mission-actions">
                        <button
                            class="btn btn-primary btn-sm btn-show-preview"
                            @click="showPreview(mission.id)">
                            <i class="fa fa-search"></i>{{ $t('common.view') }}
                        </button>
                        <button
                            class="btn btn-primary btn-sm btn-start-mission"
                            v-if="canStartMission(mission.id)"
                            @click="startMission(mission.id)"
                            :disabled="activeMission !== null && activeMission !== mission.id">
                            <i class="fa fa-play"></i
                            >{{ activeMission === mission.id ? $t('quest.go_further') : $t('quest.start') }}
                        </button>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-quest-choose-mission',
    props: ['levels', 'totalscore', 'projectId', 'usermissions'],
    data() {
        var categories = [];
        var missions = [];
        for (const level of this.levels) {
            for (const category of level.categories) {
                categories.push(category);

                for (const mission of category.missions) {
                    missions.push(mission);
                }
            }

            for (const mission of level.missions) {
                missions.push(mission);
            }
        }

        return {
            selected_level: null,
            selected_category: null,
            categories: categories,
            missions: missions,
            activeMission: null,
        };
    },
    methods: {
        selectLevel(level_id) {
            this.selected_level = level_id;
        },
        selectCategory(category_id) {
            this.selected_category = category_id;
        },
        back() {
            if (this.selected_category != null) {
                this.selected_category = null;
            } else {
                this.selected_level = null;
            }
        },
        showPreview(id) {
            window.location.href = this.routes.questMissionPreview(this.projectId, id);
        },
        startMission(id) {
            window.location.href = this.routes.questSelectMission(this.projectId, id);
        },

        checkMissionStatus(missionId) {
            for (const mission of this.usermissions) {
                if (mission.mission_id === missionId) {
                    if (mission.status === 1) {
                        return 'fa-edit';
                    }

                    if (mission.status === 2) {
                        return 'fa-hourglass-half';
                    }

                    if (mission.status === 3) {
                        return 'fa-check';
                    }
                }
            }
        },

        canStartMission(missionId) {
            for (const mission of this.usermissions) {
                if (mission.mission_id === missionId) {
                    if (mission.status === 2 || mission.status === 3) {
                        return false;
                    }
                }
            }

            return true;
        },
    },
    mounted() {
        for (const mission of this.usermissions) {
            if (mission.status === 1) {
                this.activeMission = mission.mission_id;
            }
        }
    },
};
</script>

<style scoped lang="scss">
.color-green {
    color: $green;
}

.color-red {
    color: $danger;
}

.quest-choose-mission-card {
    padding: 0;
    border: 0;

    .quest-choose-mission-card-header {
        background-color: $info;
        color: $white;
        padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'twenty-one');
        border-top-left-radius: $border-radius-content;
        border-top-right-radius: $border-radius-content;
        position: relative;

        .title {
            margin-bottom: 0;

            i {
                margin-right: map-get($grid-gutter-spacing, 'ten');
            }
        }

        .done,
        .btn-access {
            position: absolute;
            background-color: $white;
            align-self: center;
            vertical-align: middle;
            width: 55px;
            height: 55px;
            border-radius: 55px;
            bottom: -27px;
            left: calc(50% - 27px);
            text-align: center;
            padding: map-get($grid-gutter-spacing, 'ten');
            border-color: $white;

            i {
                font-size: 1.625rem;
            }
        }

        .btn-access {
            box-shadow: 0 4px 8px $border-color;
        }

        .done {
            box-shadow:
                0 2px 2px 0 rgba(163, 164, 165, 0.14),
                0 3px 1px -2px rgba(163, 164, 165, 0.2),
                0 1px 5px 0 rgba(163, 164, 165, 0.12);
            color: $green;
        }
    }

    .quest-choose-mission-card-content {
        padding: map-get($grid-gutter-spacing, 'fiften') map-get($grid-gutter-spacing, 'twenty-one')
            map-get($grid-gutter-spacing, 'twenty-one') map-get($grid-gutter-spacing, 'twenty-one');
        border-right: 1px solid $border-color;
        border-bottom: 1px solid $border-color;
        border-left: 1px solid $border-color;
        border-bottom-right-radius: $border-radius-content;
        border-bottom-left-radius: $border-radius-content;

        .card-text {
            margin-top: map-get($grid-gutter-spacing, 'ten');
            margin-bottom: map-get($grid-gutter-spacing, 'fiften');
            color: $text-muted-color;
        }
    }
}

.back {
    text-align: left;
    margin-bottom: 30px;
}

.open {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.difficulty,
.skill {
    display: flex;
    justify-content: space-between;
}

.skills {
    margin-top: map-get($grid-gutter-spacing, 'ten');
}

.skill:before {
    content: '';
    height: 20px;
    width: 5px;
    background: $secondary-background-color;
}

.skill {
    display: flex;
    justify-content: space-between;
    margin-bottom: map-get($grid-gutter-spacing, 'eight');
}

.skill-name {
    justify-content: flex-start;
    display: flex;
    flex: 1 0;
    margin-left: map-get($grid-gutter-spacing, 'five');
    margin-right: map-get($grid-gutter-spacing, 'fiften');
}

.skill-value {
    background-color: $secondary-background-color;
    color: $text-muted-color;
    padding: map-get($grid-gutter-spacing, 'eight');
    width: 25px;
    height: 25px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    font-weight: $font-weight-medium;
}

.mission-actions {
    display: flex;
    justify-content: space-between;

    .btn i {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}
</style>
